import React, {useEffect} from 'react';

import classNames from 'classnames';
import {connect} from 'react-redux';
import {useParams} from 'react-router-dom';

import {useFeatureWithAnalytics} from 'components/feature';
import {useForceRegistration} from 'desktop/hooks/useForceRegistration/useForceRegistration';
import {ApplicationStoreType} from 'desktop/store';
import {CurrentAddressType} from 'desktop/types/addressType';

import {CaliforniaPropositionPopupConnected} from './components/californiaPropositionPopup/californiaPropositionPopup';
import {CmsPopupConnected} from './components/cmsPopup/cmsPopup';
import {Sidebar} from './components/sidebar/sidebar';
import {Steps} from './components/steps/steps';
import {resetPaymentMethods} from './store/reducers/paymentStep/paymentMethods/paymentMethods';
import {startCheckoutSaga} from './store/reducers/sagaStep/sagaStep';
import {resetCheckoutSteps} from './store/reducers/status/status';
import {startCheckoutRootSaga, stopCheckoutRootSaga} from './store/sagas';
import {getIsCheckoutLoading} from './store/selectors/checkout/checkout';
import {isDeliveryStepLoaded} from './store/selectors/deliveryStep/deliveryStep';

import s from './checkoutSideReview.scss';

export type PropsType = {
    startSaga: () => void;
    resetCheckout: () => void;
    resetPayments: () => void;
    isPageLoadedBefore: boolean;
    isLoading?: boolean;
};

/**
 * CheckoutSideReview page
 *
 * @constructor
 */
export const CheckoutSideReview: React.FC<PropsType> = ({
    isLoading,
    isPageLoadedBefore,
    resetCheckout,
    resetPayments,
    startSaga,
}) => {
    const isFacelift = useFeatureWithAnalytics('dCheckoutFacelift', false, 'desktop');

    const {action = null, type = 'shipping'} = useParams<{
        type: CurrentAddressType;
        action: 'edit' | 'new';
    }>();

    useForceRegistration();

    useEffect(() => {
        startCheckoutRootSaga();

        if (!isPageLoadedBefore) {
            startSaga();
        }

        return () => {
            stopCheckoutRootSaga();
            resetCheckout();
            resetPayments();
        };
    }, []);

    return (
        <>
            <div className={classNames(s.wrapper, {[s.wrapperFacelift]: isFacelift})}>
                <div className={classNames(s.content, {[s.contentFacelift]: isFacelift})}>
                    <Steps addressType={type} isLoading={isLoading} pageType={action} />
                    <Sidebar />
                </div>
            </div>
            <CaliforniaPropositionPopupConnected />
            <CmsPopupConnected />
        </>
    );
};

const mapStateToProps = (store: ApplicationStoreType) => ({
    isLoading: getIsCheckoutLoading(store),
    isPageLoadedBefore: isDeliveryStepLoaded(store),
});

export const CheckoutSideReviewConnected = connect(mapStateToProps, {
    resetCheckout: resetCheckoutSteps,
    resetPayments: resetPaymentMethods,
    startSaga: startCheckoutSaga,
})(CheckoutSideReview);
